import { formatDistance } from "date-fns";
import type { DOMNode, HTMLReactParserOptions } from "html-react-parser";
import parse, { domToReact, Element } from "html-react-parser";

import { Link } from "../components/link";

export const parseHTML = (html: string) => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (
        domNode instanceof Element &&
        domNode.name === "a" &&
        typeof domNode.attribs.href === "string" &&
        (domNode.attribs.href.startsWith("/") ||
          domNode.attribs.href.startsWith("https://blockprotocol.org/"))
      ) {
        const { href } = domNode.attribs;

        return (
          <Link
            href={
              href.startsWith("https://blockprotocol.org/")
                ? href.replace("https://blockprotocol.org/", "/")
                : href
            }
          >
            {domToReact(domNode.children as DOMNode[], options)}
          </Link>
        );
      }
    },
  };

  return parse(html, options);
};

export const formatUpdatedAt = (date?: string | null) => {
  return date
    ? `Updated 
  ${formatDistance(new Date(date), new Date(), {
    addSuffix: true,
  })}`
    : "";
};
